<script lang="ts" generics="ITEM">
    import type {SearchParams, ViewableSearch} from 'typings/portaro.be.types';
    import type {PaginationData} from '../search-manager/pagination';
    import type {SearchManager} from '../search-manager/search-manager';
    import type {Observable} from 'rxjs';
    import {exists} from 'shared/utils/custom-utils';
    import {states} from 'shared/constants/portaro.constants';
    import KpAvailableIntents from './KpAvailableIntents.svelte';

    export let searchManager: SearchManager<ITEM>;

    const pagination = searchManager.getPagination();

    let lastSearch: Observable<ViewableSearch<SearchParams, ITEM>>;
    $: lastSearch = searchManager.getLastSearch$();

    let paginationData: Observable<PaginationData<ITEM>>;
    $: paginationData = pagination.getPaginationData$()

    function newSearchWithParams(newParams: SearchParams) {
        searchManager.newSearchWithParams(newParams);
    }
</script>

{#if exists($lastSearch) && $paginationData.state.page === states.NORMAL}
    <KpAvailableIntents availableIntents="{$lastSearch.availableIntents}"
                        newSearchWithParamsCallback="{newSearchWithParams}"/>
{/if}
